// extracted by mini-css-extract-plugin
export default {"companyInstanceManagement":"CompanyInstanceManagement_companyInstanceManagement__4vIqS"};